import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const mockData = [
  { month: 'Jan', nominal: 12000000, recovered: 1800000, target: 2000000 },
  { month: 'Feb', nominal: 11500000, recovered: 2100000, target: 2000000 },
  { month: 'Mar', nominal: 11000000, recovered: 2400000, target: 2000000 },
  { month: 'Apr', nominal: 10400000, recovered: 2200000, target: 2000000 },
  { month: 'May', nominal: 9900000, recovered: 2600000, target: 2000000 },
  { month: 'Jun', nominal: 9200000, recovered: 2800000, target: 2000000 },
];

export function PortfolioPerformanceChart() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Portfolio Performance</CardTitle>
        <CardDescription>6-month recovery trend and outstanding balance</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={mockData}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis 
              dataKey="month" 
              className="text-xs"
              stroke="hsl(var(--muted-foreground))"
            />
            <YAxis 
              className="text-xs"
              stroke="hsl(var(--muted-foreground))"
              tickFormatter={(value) => `R${(value / 1000000).toFixed(1)}M`}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
              }}
              formatter={(value: number) => `R${(value / 1000000).toFixed(2)}M`}
            />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="nominal" 
              stroke="hsl(var(--primary))" 
              strokeWidth={2}
              name="Outstanding Balance"
            />
            <Line 
              type="monotone" 
              dataKey="recovered" 
              stroke="hsl(var(--chart-2))" 
              strokeWidth={2}
              name="Recovered"
            />
            <Line 
              type="monotone" 
              dataKey="target" 
              stroke="hsl(var(--chart-3))" 
              strokeWidth={2}
              strokeDasharray="5 5"
              name="Target"
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
